angular.module('aprima-legacy-common').run(['CustomModuleRunService', function(CustomModuleRunService) {
    'use strict';
    CustomModuleRunService.add(
    ['$rootScope', '$location', '$log', 'AprimaAnalytics', '$state',
    function ($rootScope, $location, $log, AprimaAnalytics, $state) {

        $rootScope.$watch(function () {
                return $location.path();
            },
            function (a) {
                var output = ($state.current.description) ? $state.current.description : a;
                $log.info('url has changed: ' + output);
                AprimaAnalytics.sendPageView(output);
            });
    }
    ]);
}]);
